import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Code2, Plus, Trash2 } from 'lucide-react';
import { FieldError, SectionHeader, dangerButton, inputClass, profileCard, subtleButton } from './ProfileUI';

const emptyProject = { title: '', description: '' };

const ProjectsSection = ({ projects, onChange, errors = [] }) => {
  const updateProject = (index, field, value) => {
    onChange(projects.map((project, projectIndex) => (projectIndex === index ? { ...project, [field]: value } : project)));
  };

  const addProject = () => {
    onChange([...projects, { ...emptyProject }]);
  };

  const removeProject = (index) => {
    onChange(projects.filter((_, projectIndex) => projectIndex !== index));
  };

  return (
    <section className={profileCard}>
      <SectionHeader
        icon={Code2}
        eyebrow="Step 04"
        title="Project portfolio"
        action={
          <button type="button" onClick={addProject} className={subtleButton}>
          <Plus className="h-4 w-4" />
          Add
        </button>
        }
      />
      <div className="mt-4 space-y-4">
        <AnimatePresence initial={false}>
          {projects.map((project, index) => (
          <motion.div
            key={index}
            layout
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            className="rounded-2xl border border-slate-700/50 bg-slate-900/50 p-4 transition hover:border-purple-400/50 hover:shadow-lg hover:shadow-purple-500/10"
          >
            <div className="mb-3 flex items-center justify-between gap-3">
              <span className="rounded-full border border-purple-400/20 bg-purple-500/20 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-purple-300">
                Project {index + 1}
              </span>
            </div>
            <input className={inputClass} placeholder="Project title" value={project.title} onChange={(event) => updateProject(index, 'title', event.target.value)} />
            <textarea className={`${inputClass} mt-3 min-h-32 resize-y leading-6`} placeholder="Project description, role, stack, measurable outcomes" value={project.description} onChange={(event) => updateProject(index, 'description', event.target.value)} />
            <FieldError>{errors[index]}</FieldError>
            <button type="button" onClick={() => removeProject(index)} className={`${dangerButton} mt-3`}>
              <Trash2 className="h-4 w-4" />
              Remove
            </button>
          </motion.div>
          ))}
        </AnimatePresence>
        {!projects.length && (
          <div className="rounded-2xl border border-dashed border-white/15 bg-slate-950/30 p-6 text-center text-sm text-slate-400">
            Add projects that show what you can build. Strong examples improve career recommendations.
          </div>
        )}
      </div>
    </section>
  );
};

export default ProjectsSection;
